import { PlansColumns } from '../models';

export const inputFieldLabel = ['Account Number', 'Service Point Id', 'Meter Id'];

export const defaultRatePlanCategoryValue = { key: '', value: '', effectiveDate: '2024-9-1' };

export const searchCategory = [
  {
    value: 'Account Number',
    label: 'Search By Account Number',
  },
  {
    value: 'Service Point Id',
    label: 'Search By Service Point Id',
  },
  {
    value: 'Meter Id',
    label: 'Search By Meter Id',
  },
  {
    value: 'Rate Plans',
    label: 'Search By Rate Plans',
  },
  {
    value: 'Special Error Cases',
    label: 'Search By Special Error Cases',
  },
];

export const ratePlanCategory = [
  {
    value: 'WRD1',
    label: 'RD1 - Peak Nights and Weekends',
    effectiveDate: '2024-12-1',
  },
  {
    value: 'WRG1',
    label: 'RG1 - Residential Electric Service',
    effectiveDate: '2024-12-1',
  },
  {
    value: 'WRG5',
    label: 'RG5 - Nights and Weekends',
    effectiveDate: '2024-12-1',
  },
  {
    value: 'IA400',
    label: '400 - Electric Residential',
    effectiveDate: '2024-9-1',
  },
  {
    value: 'IA407',
    label: '407 - Electric Residential TOD',
    effectiveDate: '2024-9-1',
  },
  {
    value: 'IA427',
    label: '427 - Electric Residential TOD',
  },
  {
    value: 'WGS1',
    label: 'GS1 - General Service',
    effectiveDate: '2024-12-1',
  },
  {
    value: 'WGS3',
    label: 'GS3 - General Service Time-Of-Use',
    effectiveDate: '2024-12-1',
  },
  {
    value: 'WGD1',
    label: 'GD1 - General Service Demand Rate',
    effectiveDate: '2024-12-1',
  },
  {
    value: 'IA600',
    label: '600 - Electric Non-Residential General Service',
    effectiveDate: '2024-9-1',
  },
  {
    value: 'IA607',
    label: '607 - Electric Non-Residential TOD',
    effectiveDate: '2024-9-1',
  },
  {
    value: 'I507P',
    label: '507 - Residential Peak Demand',
    effectiveDate: '2024-9-1', // Actual effective Date is Feb. 2025
  },
  {
    value: 'I707P',
    label: '707 - Business Peak Demand',
    effectiveDate: '2024-9-1', // Actual effective Date is Feb. 2025
  },
];

export const errorCaseCategory = [
  {
    value: 'Fixed amount bill',
    label: 'Fixed amount bill',
  },
  {
    value: 'No active meters',
    label: 'No active meters',
  },
  {
    value: 'Service less than 12 months',
    label: 'Service less than 12 months',
  },
  {
    value: 'Rate switch in progress',
    label: 'Rate switch in progress',
  },
  {
    value: 'Payment plan',
    label: 'Payment plan',
    validOnly: true,
  },
  {
    value: 'Budget billing',
    label: 'Budget billing',
    validOnly: true,
  },
  {
    value: 'Less than 12 months usage data',
    label: 'Less than 12 months usage data',
  },
  {
    value: 'High demand usage',
    label: 'High demand usage',
    validOnly: true,
  },
  {
    value: 'High annual usage',
    label: 'High annual usage',
    validOnly: true,
  },
  {
    value: 'Severance',
    label: 'Severance',
    validOnly: true,
  },
  {
    value: 'Ineligible to switch',
    label: 'Ineligible to switch',
  },
  {
    value: 'Recently switched',
    label: 'Recently switched',
  },
  {
    value: 'More than 10% usage difference',
    label: 'More than 10% usage difference',
  },
];

export const stateDropDown = [{
  value: 'WI',
  label: 'Wisconsin (WI)',
}, {
  value: 'IA',
  label: 'Iowa (IA)',
}];

export const stateLabel = 'States';

export const BillChargeType = {
  onPeakUsage: ['On-Peak Energy Charge', 'Energy Charge', 'High Energy Charge', 'Winter On Peak Energy',
    'Winter 1st Step', 'Summer 3rd Step', 'Winter Energy', 'Summer Energy', 'Summer On Peak Energy'],
  midPeakUsage: ['Mid-Peak Energy Charge', 'Regular Energy Charge', 'Winter 2nd Step', 'Summer 2nd Step'],
  offPeakUsage: ['Off-Peak Energy Charge', 'Low Energy Charge', 'Winter 3rd Step',
    'Summer 1st Step', 'Winter Off Peak Energy', 'Summer Off Peak Energy'],
  superOffPeakUsage: ['Super-Off-Peak Energy Charge', 'Winter Super Off Peak Energy', 'Summer Super Off Peak Energy'],
  onPeakCharge:
  ['On-Peak Energy Charge', 'Energy Charge', 'High Energy Charge', 'Summer On Peak Energy', 'Winter On Peak Energy', 'Winter Energy'],
  midPeakCharge: ['Mid-Peak Energy Charge', 'Regular Energy Charge'],
  offPeakCharge: ['Off-Peak Energy Charge', 'Low Energy Charge', 'Summer Off Peak Energy', 'Winter Off Peak Energy'],
  superOffPeakCharge: ['Super-Off-Peak Energy Charge'],
  serviceCharge: ['Basic Service Charge', 'Customer Charge'],
  onPeakDemandCharge: ['On-Peak Demand Charge', 'Winter Demand', 'Summer Demand'],
  customerDemandCharge: ['Customer Demand Charge'],
  threePhaseCustomerCharge: ['Three Phase Customer Charge', 'Three Phase Service Charge'],
  winter1Step: ['Winter 1st Step'],
  winter2Step: ['Winter 2nd Step'],
  winter3Step: ['Winter 3rd Step'],
  summer1Step: ['Summer 1st Step'],
  summer2Step: ['Summer 2nd Step'],
  summer3Step: ['Summer 3rd Step'],
};

export enum TableColumnIdEnum {
  Month,
  BillStartDate,
  BillEndDate,
  BillDays,
  OnPeakUsage,
  MidPeakUsage,
  OffPeakUsage,
  SuperOffPeakUsage,
  TotalUsage,
  OnPeakCost,
  MidPeakCost,
  OffPeakCost,
  SuperOffPeakCost,
  WinterStep1Cost,
  WinterStep2Cost,
  WinterStep3Cost,
  SummerStep1Cost,
  SummerStep2Cost,
  SummerStep3Cost,
  TotalEnergyCost,
  BasicServiceCost,
  OnPeakDemandCost,
  CustomerDemandCost,
  FuelAdjustmentCharge,
  ThreePhaseCustomerCharge,
  Total,
  TotalDiff,
  TotalBilled,
  Ignored,
}

export const PlanColumns: PlansColumns = {
  400: [
    {
      effectiveFrom: '2024-9-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.TotalUsage, TableColumnIdEnum.TotalEnergyCost,
        TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.Total,
        TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],
    },
  ],
  407: [
    {
      effectiveFrom: '2024-9-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.OnPeakUsage, TableColumnIdEnum.OffPeakUsage,
        TableColumnIdEnum.TotalUsage, TableColumnIdEnum.OnPeakCost, TableColumnIdEnum.OffPeakCost,
        TableColumnIdEnum.TotalEnergyCost, TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.Total,
        TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],

    },
  ],
  RG1: [
    {
      effectiveFrom: '2024-12-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.TotalUsage, TableColumnIdEnum.TotalEnergyCost,
        TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.FuelAdjustmentCharge, TableColumnIdEnum.Total,
        TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],
    },
  ],
  RG5: [
    {
      effectiveFrom: '2024-12-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.OnPeakUsage, TableColumnIdEnum.MidPeakUsage, TableColumnIdEnum.OffPeakUsage,
        TableColumnIdEnum.TotalUsage, TableColumnIdEnum.OnPeakCost, TableColumnIdEnum.MidPeakCost, TableColumnIdEnum.OffPeakCost,
        TableColumnIdEnum.TotalEnergyCost, TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.FuelAdjustmentCharge,
        TableColumnIdEnum.Total, TableColumnIdEnum.TotalDiff,
        TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],
    },
  ],
  RD1: [
    {
      effectiveFrom: '2024-12-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.OnPeakUsage, TableColumnIdEnum.MidPeakUsage, TableColumnIdEnum.OffPeakUsage,
        TableColumnIdEnum.TotalUsage, TableColumnIdEnum.OnPeakCost, TableColumnIdEnum.MidPeakCost, TableColumnIdEnum.OffPeakCost,
        TableColumnIdEnum.TotalEnergyCost, TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.FuelAdjustmentCharge,
        TableColumnIdEnum.OnPeakDemandCost, TableColumnIdEnum.Total,
        TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],
    },
  ],
  600: [
    {
      effectiveFrom: '2024-9-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.TotalUsage, TableColumnIdEnum.TotalEnergyCost,
        TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.ThreePhaseCustomerCharge, TableColumnIdEnum.Total,
        TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],
    },
  ],
  607: [
    {
      effectiveFrom: '2024-9-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.OnPeakUsage, TableColumnIdEnum.OffPeakUsage,
        TableColumnIdEnum.TotalUsage, TableColumnIdEnum.OnPeakCost, TableColumnIdEnum.OffPeakCost,
        TableColumnIdEnum.TotalEnergyCost, TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.ThreePhaseCustomerCharge,
        TableColumnIdEnum.Total, TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],
    },
  ],
  GS1: [
    {
      effectiveFrom: '2024-12-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.TotalUsage,
        TableColumnIdEnum.TotalEnergyCost, TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.FuelAdjustmentCharge,
        TableColumnIdEnum.Total,
        TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],
    },
  ],
  GS3: [
    {
      effectiveFrom: '2024-12-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.OnPeakUsage, TableColumnIdEnum.MidPeakUsage, TableColumnIdEnum.OffPeakUsage,
        TableColumnIdEnum.TotalUsage, TableColumnIdEnum.OnPeakCost, TableColumnIdEnum.MidPeakCost, TableColumnIdEnum.OffPeakCost,
        TableColumnIdEnum.TotalEnergyCost, TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.FuelAdjustmentCharge,
        TableColumnIdEnum.Total,
        TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],
    },
  ],
  GD1: [
    {
      effectiveFrom: '2024-12-1',
      columns: [
        TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate,
        TableColumnIdEnum.BillDays, TableColumnIdEnum.OnPeakUsage, TableColumnIdEnum.MidPeakUsage, TableColumnIdEnum.OffPeakUsage,
        TableColumnIdEnum.TotalUsage, TableColumnIdEnum.OnPeakCost, TableColumnIdEnum.MidPeakCost, TableColumnIdEnum.OffPeakCost,
        TableColumnIdEnum.TotalEnergyCost, TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.OnPeakDemandCost,
        TableColumnIdEnum.CustomerDemandCost, TableColumnIdEnum.FuelAdjustmentCharge, TableColumnIdEnum.Total, TableColumnIdEnum.TotalDiff,
        TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
      ],
    },
  ],
  427: [{
    columns: [
      TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate, TableColumnIdEnum.BillDays,
      TableColumnIdEnum.OnPeakUsage, TableColumnIdEnum.OffPeakUsage, TableColumnIdEnum.SuperOffPeakUsage,
      TableColumnIdEnum.TotalUsage, TableColumnIdEnum.OnPeakCost, TableColumnIdEnum.OffPeakCost, TableColumnIdEnum.SuperOffPeakCost,
      TableColumnIdEnum.TotalEnergyCost, TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.Total,
      TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
    ],
  }],
  507: [{
    columns: [
      TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate, TableColumnIdEnum.BillDays,
      TableColumnIdEnum.OnPeakUsage, TableColumnIdEnum.OffPeakUsage, TableColumnIdEnum.TotalUsage,
      TableColumnIdEnum.OnPeakCost, TableColumnIdEnum.OffPeakCost, TableColumnIdEnum.TotalEnergyCost,
      TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.OnPeakDemandCost, TableColumnIdEnum.Total,
      TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
    ],
  }],
  707: [{
    columns: [
      TableColumnIdEnum.Month, TableColumnIdEnum.BillStartDate, TableColumnIdEnum.BillEndDate, TableColumnIdEnum.BillDays,
      TableColumnIdEnum.OnPeakUsage, TableColumnIdEnum.OffPeakUsage, TableColumnIdEnum.TotalUsage,
      TableColumnIdEnum.OnPeakCost, TableColumnIdEnum.OffPeakCost, TableColumnIdEnum.TotalEnergyCost,
      TableColumnIdEnum.BasicServiceCost, TableColumnIdEnum.OnPeakDemandCost, TableColumnIdEnum.ThreePhaseCustomerCharge,
      TableColumnIdEnum.Total, TableColumnIdEnum.TotalDiff, TableColumnIdEnum.TotalBilled, TableColumnIdEnum.Ignored,
    ],
  }],
};
